// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Sm-z","title":"Tm-z","nav":"Um-z","flexCell":"Vm-z","facetLink":"Wm-z"};